import * as types from '../actions/actionTypes'
import intialState from './initialState'

export default function searchReducer (state = intialState.global, action) {
    switch (action.type) {
        case types.SET_GLOBAL_SEARCH_KEY:
            return {
                ...state,
                searchKey: action.search
            }
        default:
            return state
    }
}
